import * as actions from './actionTypes'
import { initActions } from '../middlewares/init'
const combineActions = (...actions) => {
  return actions.reduce((result, action) => {
    return {
      ...result,
      ...action
    }
  }, {})
}

export default combineActions(actions, initActions)
